import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import Modal from '../modal';
import Spinner from '../spinner';
import { getEnvironment } from '../../utilities/browser';
import { LoginIframe } from './styles/login.styled';
const loginEnvironment = {
    ontw: 'login-ontw',
    test: 'login-test',
    acc: 'login-acc',
    prod: 'login',
}[getEnvironment()];
/**
 * The iframe inside the popup should control the height of the popup itself via
 * window.top.postMessage. However, if that mechanism fails for whatever reason,
 * the popup should have an initial height of 381.
 */
const HEIGHT_LOGIN_IFRAME = 381;
/**
 * The Login Application component which will be used for local development
 */
let LoginInContextApplication;
class Login extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            open: true,
            loading: false,
            iframe: PRODUCTION,
            height: HEIGHT_LOGIN_IFRAME,
        };
        this.messsageListener = ({ data }) => {
            if (data === 'loggedIn') {
                const { onLogin } = this.props;
                this.setState({ open: false });
                if (onLogin)
                    onLogin();
            }
            if (typeof data === 'object' && data.type === 'bodyResize' && typeof data.value === 'number') {
                if (this.state.height !== data.value) {
                    this.setState({ height: data.value });
                }
            }
        };
        this.addMesssageListener = () => {
            window.addEventListener('message', this.messsageListener);
        };
        this.removeMesssageListener = () => {
            window.removeEventListener('message', this.messsageListener);
        };
        this.loadSSOLoginInContext = () => {
            return import('./sso-login-in-context' /* webpackChunkName: "sso-login-in-context" */);
        };
    }
    componentDidMount() {
        const { iframe } = this.state;
        this.addMesssageListener();
        if (!iframe) {
            this.setState({ loading: true }, () => {
                this.loadSSOLoginInContext()
                    .then(({ default: component }) => {
                    LoginInContextApplication = component;
                    this.setState({ loading: false });
                })
                    .catch((error) => {
                    this.setState({ loading: false });
                    throw error;
                });
            });
        }
    }
    componentWillUnmount() {
        this.removeMesssageListener();
    }
    render() {
        const { onOpen, onClose } = this.props;
        const { open, iframe, loading } = this.state;
        /**
         * The url on which the login iframe is hosted.
         * This contains the url to which the user is redirected after login (redirect_uri).
         */
        const iframeTarget = `https://${loginEnvironment}.anwb.nl/?context=true&redirect_uri=${encodeURI(window.location.href)}`;
        const renderSpinner = loading ? _jsx(Spinner, { "data-test": "spinner" }) : null;
        const renderContextApplication = LoginInContextApplication ? (_jsx(LoginInContextApplication, {})) : (renderSpinner);
        const handleOpenChange = (isOpen) => {
            if (isOpen) {
                onOpen === null || onOpen === void 0 ? void 0 : onOpen();
            }
            else {
                onClose === null || onClose === void 0 ? void 0 : onClose();
            }
        };
        return (_jsx(Modal, { "data-test": "modal", open: open, size: "l", onOpenChange: handleOpenChange, fullSize: iframe || loading || !!LoginInContextApplication, children: iframe ? (_jsx(LoginIframe, { "data-test": "iframe", title: "login-application", sandbox: "allow-forms allow-scripts allow-same-origin allow-top-navigation allow-top-navigation-by-user-activation", src: iframeTarget, className: "ANWB-login", height: `${this.state.height}px` })) : (renderContextApplication) }));
    }
}
Login.defaultProps = {
    componentName: 'login',
};
export default Login;
